module.exports = __webpack_public_path__ + "static/media/img-8.7e74f898.jpg";